/**************************************************
 * Nombre:       Login
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography, useMediaQuery} from "@mui/material";
import {theme} from "../Tema";
import './login.css'
import Registro from "./Vistas/Registro";
import {useEffect, useState} from "react";
import Ingreso from "./Vistas/Ingreso";
import {obtenerParametro} from "../Utilidades/obtenerParametro";

const Login = ({logo, logoRedondo}) => {
    const sCell = useMediaQuery(theme.breakpoints.only('xs'))
    const masSM = useMediaQuery(theme.breakpoints.up('md'))
    const [esRegistro, setEsRegistro] = useState(false)

    const cambiar = () => {
        setEsRegistro(!esRegistro)
    }

    useEffect(() => {
        let id = obtenerParametro('id')
        if (id === 'registro') {
            setEsRegistro(true)
        }

    }, [])
    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            size={12}
            sx={{backgroundColor: theme.palette.primary.main}}
        >





            <Grid container size={{xs: 12, sm: 5, md: 7}} className={masSM ? 'clase' : 'claseCell'}
                  sx={{justifyContent: 'center', py: 6, backgroundColor: '#000', minHeight: sCell ? '30vh' : '100vh'}}>
                <img src={logo} width={'30%'} height={'auto'} alt={'Logo empresa'} title={'Logo'}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 7, md: 5}} sx={{justifyContent: 'center'}}>
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems="center"
                    size={12}
                    sx={{backgroundColor: '#fff', minHeight: sCell ? '45vh' : '100vh', px: sCell ? 4 : 0}}
                >


                    <Grid container size={{xs: 12, sm: 9, md: 8}} sx={{justifyContent: 'flex-start'}}>
                        {esRegistro ?

                            <Registro clickRegistro={cambiar}/>

                            :

                            <Ingreso clickRegistro={cambiar}/>
                        }

                    </Grid>


                </Grid>
            </Grid>


        </Grid>
    )

}
export default Login    